import { Exception } from "util/domain/exception";

export enum LinkAuthError {
    INVALID_PASSWORD = 'INVALID_PASSWORD',
    LINK_EXPIRED = 'LINK_EXPIRED',
    INVALID_ACCESS_CODE = 'INVALID_ACCESS_CODE',
    LINK_NOT_FOUND = 'LINK_NOT_FOUND',
    DEFAULT = 'DEFAULT'
}

export class LinkAuthException extends Exception<LinkAuthError> {

    constructor(
        public gettextCatalog:ng.gettext.gettextCatalog,
        errorCode:LinkAuthError,
    ){
        super(errorCode, LinkAuthError[errorCode], 'An error occurred authorizing a link');
        this.userMessage = this.generateUserMessage();
    }
    private generateUserMessage() {
        let msg = this.gettextCatalog.getString(`Invalid or expired link.`);
        switch(this.type){
            case LinkAuthError.INVALID_PASSWORD:
                msg = this.gettextCatalog.getString(`Invalid password entered`);
                break;
            case LinkAuthError.INVALID_ACCESS_CODE:
                msg = this.gettextCatalog.getString(`Invalid access code entered`);
                break;
            case LinkAuthError.LINK_EXPIRED:
                msg = this.gettextCatalog.getString(`Link expired`);
                break;
            case LinkAuthError.LINK_NOT_FOUND:
                msg = this.gettextCatalog.getString(`Invalid link`);
                break;
        }
        
        return msg;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/link-authorization-exception.ts